import React from "react"
import { Box, Paper, Grid, Divider } from "@mui/material"

import { makeStyles } from "makeStyles"

import Button from "components/Buttons/Button"
import Link from "components/i18n/Link"
import Price from "components/Price"
import LazyLoadedImage from "components/LazyLoadedImage"

import { AlgoliaLockingSystemHit } from "@secureo/common/typings/Algolia"

const useStyles = makeStyles()({
	attributes: {
		visibility: "hidden",
		marginTop: "-90px",
		opacity: 0.4,
	},
	button: {
		background: "#E3E5E6",
	},
	title: {
		color: "black",
		cursor: "pointer",
	},
	product: {
		boxShadow: "none",
		border: "1px solid whitesmoke",
		borderRadius: 10,
		transition: "0.3s",
		position: "relative",
		"&:hover": {
			boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.35)",
			border: "1px solid #4691CE",
			"& $button": {
				background: "#4691CE",
				color: "white",
				boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.35)",
			},
			"& $title": {
				color: "#4691CE",
			},
		},
	},
	badge: {
		position: "absolute",
		top: 15,
		left: 15,
		fontSize: 10,
		textTransform: "uppercase",
		border: "1px solid #4691CE",
		color: "#4691CE",
		borderRadius: 5,
		paddingLeft: 5,
		paddingRight: 5,
		"&:hover": {
			color: "white",
			background: "#4691CE",
			cursor: "pointer",
		},
	},
})

const LockingSystemListViewItem = ({ hit }: Props) => {
	const { classes } = useStyles()

	const { name, image, slug, previewBulletPoints, securityScore = null, grossPriceCents } = hit

	return (
		<Link href={`/locking-system/${slug}`}>
			<div style={{ position: "relative" }}>
				<Paper className={classes.product}>
					<Grid container spacing={0}>
						<Grid item xs={12} md={3}>
							<Box py={2} style={{ textAlign: "center" }}>
								<LazyLoadedImage
									alt={name}
									title={name}
									src={image}
									style={{
										height: 130,
										maxWidth: 200,
										objectFit: "contain",
										width: "100%",
										margin: "auto",
									}}
								/>
							</Box>
						</Grid>

						<Grid item xs={12} md={6}>
							<Box p={1}>
								<Box mt={1} className={classes.title}>
									<strong>{name}</strong>
									{securityScore !== null && (
										<span>
											<br />
											Sicherheitsstufe: {securityScore} / 10
										</span>
									)}
								</Box>
								<Box my={1}>
									<Divider />
								</Box>
								<ul style={{ paddingLeft: 20 }}>
									{previewBulletPoints.map((previewBulletPoint) => (
										<li key={previewBulletPoint}>{previewBulletPoint}</li>
									))}
								</ul>
							</Box>
						</Grid>

						<Grid
							item
							xs={12}
							md={3}
							style={{
								background: "#E7EFF6",
								borderTopRightRadius: 10,
								borderBottomRightRadius: 10,
							}}
						>
							<Box mt={4} px={2}>
								<Box ml={1} mt={1}>
									<strong style={{ fontSize: 22, marginRight: 5 }}>
										<Price priceInEuroCents={grossPriceCents} />
									</strong>
									<span style={{ color: "grey", fontSize: 12 }}>inkl. MwSt.</span>
								</Box>
								<Box my={2}>
									<Button color="primary" aria-label="to-product" size="small">
										Zum System
									</Button>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Paper>
			</div>
		</Link>
	)
}

interface Props {
	hit: AlgoliaLockingSystemHit
	locale: string
	position: number
	categoryName: string
	listName?: string
}

export default LockingSystemListViewItem
